import { render, staticRenderFns } from "./registeredSubAccount.vue?vue&type=template&id=1fe7b892&scoped=true&"
import script from "./registeredSubAccount.vue?vue&type=script&lang=js&"
export * from "./registeredSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./registeredSubAccount.vue?vue&type=style&index=0&id=1fe7b892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7b892",
  null
  
)

component.options.__file = "registeredSubAccount.vue"
export default component.exports